import * as Website from '../Config/Website.js';

const loadYouTubeAPI = () => {
  // 複数のトリガーボタンを取得
  const movieTriggers = document.querySelectorAll('.js-movie-trigger');
  const movieDialog = document.querySelector('.js-movie-dialog');
  const movieDialogBackground = document.querySelector('.js-movie-dialog-background');
  const movieClose = document.querySelector('.js-movie-dialog-close');
  // 必須要素が存在しない場合は処理を中断
  if (movieTriggers.length === 0 || !movieDialog || !movieDialogBackground || !movieClose) {
    // console.warn('YouTube modal: 必要な要素が見つかりません');
    return;
  }
  // プレイヤーを格納する変数
  let targetPlayer = null;
  let currentVideoId = null;
  // [1]. Youtube IFrame Player APIの読込
  // 既に読み込まれている場合はスキップ
  if (!window.YT) {
    const makeScriptTag = document.createElement('script');
    makeScriptTag.src = "https://www.youtube.com/iframe_api";
    const asyncScriptTag = document.getElementsByTagName('script')[0];
    asyncScriptTag.parentNode.insertBefore(makeScriptTag, asyncScriptTag);
  }
  // [2]. Youtube IFrame Player APIが実行してくれる関数の定義
  window.onYouTubeIframeAPIReady = function() {
    const playerElement = document.getElementById('targetPlayer');
    if (!playerElement) {
      // console.error('YouTube player element (#targetPlayer) が見つかりません');
      return;
    }
    // 初期状態ではプレイヤーを作成せず、動画IDだけ保持
    // console.log('YouTube API の準備が完了しました');
    // すべてのトリガーボタンを有効化
    movieTriggers.forEach(trigger => {
      trigger.classList.add('is-ready');
    });
  };
  // [3]. プレイヤーを作成または動画を切り替える関数
  function loadVideo(videoId) {
    const playerElement = document.getElementById('targetPlayer');
    if (!playerElement) {
      // console.error('YouTube player element (#targetPlayer) が見つかりません');
      return;
    }
    if (!targetPlayer) {
      // プレイヤーが未作成の場合は新規作成
      targetPlayer = new YT.Player('targetPlayer', {
        videoId: videoId,
        playerVars: {
          autoplay: 1,        // 自動再生
          controls: 1,        // コントロールを表示
          rel: 0,             // 関連動画を表示しない
          modestbranding: 1,  // YouTubeロゴを控えめに
          playsinline: 1      // iOSでインライン再生
        },
        events: {
          'onReady': onPlayerReady,
          // 'onStateChange': onPlayerStateChange
        }
      });
    } else {
      // 既にプレイヤーが存在する場合は動画を切り替え
      targetPlayer.loadVideoById(videoId);
      targetPlayer.mute();
      targetPlayer.playVideo();
    }
    currentVideoId = videoId;
  }
  // [4]. 再生準備ができた時の処理
  function onPlayerReady(event) {
    // console.log('YouTube player is ready');
    event.target.mute();
    event.target.playVideo();
  }
  // [5]. プレイヤーの状態変化を監視
  // function onPlayerStateChange(event) {
  //   // 動画が終了したら（YT.PlayerState.ENDED = 0）
  //   if (event.data === YT.PlayerState.ENDED) {
  //     closeModal();
  //   }
  // }
  // [6]. モーダルを開く関数
  function openModal(videoId) {
    if (!window.YT || !window.YT.Player) {
      // console.error('YouTube API がまだ読み込まれていません');
      return;
    }
    movieDialog.classList.add(Website.classList.actOpen);
    movieDialogBackground.classList.add(Website.classList.actOpen);
    // body のスクロールを無効化
    document.body.style.overflow = 'hidden';
    // 動画を読み込んで再生
    loadVideo(videoId);
  }
  // [7]. モーダルを閉じる関数
  function closeModal() {
    movieDialog.classList.remove(Website.classList.actOpen);
    movieDialogBackground.classList.remove(Website.classList.actOpen);
    // body のスクロールを有効化
    document.body.style.overflow = '';
    // 動画を停止
    if (targetPlayer && typeof targetPlayer.stopVideo === 'function') {
      targetPlayer.stopVideo();
    }
  }
  // [8]. イベントリスナーの設定
  // 各トリガーボタンにイベントを設定
  movieTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      // data-video-id属性から動画IDを取得
      const videoId = trigger.dataset.videoId;
      if (!videoId) {
        // console.error('data-video-id が設定されていません', trigger);
        return;
      }
      openModal(videoId);
    });
  });
  // 背景クリックで閉じる
  movieDialogBackground.addEventListener('click', (e) => {
    closeModal();
  });
  // 閉じるボタン
  movieClose.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal();
  });
  // Escキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && movieDialog.classList.contains(Website.classList.actOpen)) {
      closeModal();
    }
  });
  // APIが既に読み込まれている場合は直ちに実行
  if (window.YT && window.YT.Player) {
    window.onYouTubeIframeAPIReady();
  }
};

const init = () => {
  loadYouTubeAPI();
};

export default init;